<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MbsHey/tc-custom/9781429949880.jpg?1737748006034" alt="This image is the cover for the book Spellbound, The Spellwright Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spellbound, The Spellwright Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A Kirkus Reviews Best Science Fiction &amp; Fantasy of the year, Blake Charlton's <i>Spellbound </i>is the exciting sequel to the acclaimed epic fantasy debut <i>Spellwright</i>.</b><br/><br/> In a world where one's magical prowess is determined by one's skill with words and ability to spell, Nicodemus is a wizardly apprentice afflicted by a curse that causes him to misspell magical texts. Now, the demon who cursed him has hatched a conspiracy to force Nicodemus to change language and ultimately use it to destroy all human life.<br/><br/> As Nico tries to thwart the demon's plan, he faces challenges from all sides. But his biggest challenge is his own disability, which causes him to create chaos wherever he goes. And the chaos surrounding Nico is affecting the world so profoundly that the kingdom to which he has fled to gather strength is on the brink of civil war, and he suspects that his closest allies--even Francesca, whom he loves more than life itself--may be subject to the demon's vast powers.<br/><br/> As Nico tries to forestall the apocalypse, he realizes that he doesn't know if he can fully trust anyone, not even the woman he loves. And if he makes one wrong move, not only will his life be forfeit, he may end up destroying all mortal life as well. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Blake Charlton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cae25f4c